import {ReactNode, useEffect} from "react";
import {
  Setting,
  SettingsApi
} from "@/pages/SystemAdmin/Settings/SettingsApi.ts";
import {ModalSize, useModal} from "@fs/uikit-react";

export let refreshSettings = () => {}
export let openModal: ((size: ModalSize, title: string, content: ReactNode) => void);

export const useInit = (
  setSettings: (value: Setting[]) => void,
  setLoading: (value: boolean) => void,
  setError: (value: unknown) => void) => {

  openModal = useModal().openModal;

  useEffect(() => {
    refreshSettings = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await SettingsApi.getAll();
        setSettings(response.data);
      } catch (err) {
        setError(err);
        console.error('Error fetching settings:', err);
      } finally {
        setLoading(false);
      }
    };
  }, [setSettings, setLoading, setError]);
}
